import React from 'react';
import api from 'api';

import FullPreset from './presets/full';
import SimplePreset from './presets/simple';
import Help from './Help';

import { getMentions } from './getMentions';
import { getExtraMenu } from './extraMenu';
import { BasicRichText } from './BasicRichText';

export const resolveType = (pairs) => new Promise((resolve, reject) => {
  api.search.resolve(pairs, (data) => {
    resolve(data);
  }, (err) => {
    reject(err);
  });
});

class RichText extends React.PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      mentions: {},
      lastQuery: '',
      lastKind: null,
      chooser: {},
    };

    this.timeout = null;
  }

  getThrottledMentions(kind, query) {
    if (this.timeout) {
      clearTimeout(this.timeout);
    }

    this.timeout = setTimeout(() => {
      getMentions(kind, query).then((result) => {
        this.setState(() => ({
          lastKind: kind,
          lastQuery: query,
          mentions: result,
        }));
      });
    }, 300);
  }

  onChange = (val) => {
    const { onChange, extraData } = this.props;
    if (onChange) {
      return onChange(val, extraData);
    }
  };

  setChooser = (kind, open, cmd, text) => this.setState(() => ({ chooser: { [kind]: { open, cmd, text } } }));

  render() {
    const {
      forType, forId, simple, onChange: _onChange, extraData: _extraData, ...rest
    } = this.props;
    const { chooser } = this.state;
    return <>
      <BasicRichText
        {...rest}
        options={simple ? SimplePreset : FullPreset}
        mentions={this.state.mentions}
        onSuggest={(kind, query) => this.getThrottledMentions(kind, query)}
        extraMenuItems={simple ? [] : getExtraMenu(chooser, this.setChooser.bind(this), forType, forId)}
        HelpText={<Help />}
        onChange={this.onChange.bind(this)}
        settings={{
          uploadOptions: { forType, forId },
          resolveType,
        }}
      />
    </>;
  }
}

// Ideas are a bit poorly optimised when it comes to updates, by wrapping the handlers a bit differently for fields we save a decent amount of unnecessary updates
const RichTextField = React.memo(({ updateIdea, field, ...props }) => <RichText
    stickyMenu={true}
    stickyMenuOffset={140}
    emptyReturnValue={null}
    historyEnabled={false}
    onChange={(val) => updateIdea(val, ['templated', field.id])}
    {...props}
  />);
export { RichTextField };

export default RichText;
